import { render } from "./PopupTemplate.vue?vue&type=template&id=051530d8"
import script from "./PopupTemplate.vue?vue&type=script&lang=js"
export * from "./PopupTemplate.vue?vue&type=script&lang=js"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__